export const SHIP_IT = 'ShipIt';
export const PICK_UP = 'Pickup';
export const SAME_DAY = 'SameDay';

export type FulfillmentRadioButton = typeof SHIP_IT | typeof PICK_UP | typeof SAME_DAY;
